// src/components/ShareSheet.tsx
//
// ══════════════════════════════════════════════════════════════════════════
// PAYLAŞ SHEET'İ — TEMBEL GİRİŞ KAPISI (gövde: `./ShareSheetIcerik`)
// ══════════════════════════════════════════════════════════════════════════
//
// ── NİYE İKİYE AYRILDI: ÖLÇÜLEN KUSUR ────────────────────────────────────
// #1030 birleştiğinde `npm run build` → `İLK PAKET KAPISI` KIRMIZI verdi.
// Kaynak-haritası tabanlı modül atfıyla (`main.*.js.map`) sebep tek tek
// ölçüldü — ana pakete YENİ giren modüller ve ham baytları:
//
//     35 026  myclipsv3/feed/clipsRepo.ts          ← FriendPickerModal çekti
//     10 225  myclipsv3/data/turkeyDistrictToCity.ts
//      8 363  services/dm.ts
//      4 149  myclipsv3/monitoring/sentry.ts
//      4 063  components/ShareSheet.tsx (gövde)
//      3 904  geofire-common
//      3 850  FriendPickerModal.tsx
//      3 134  components/BottomSheet.tsx
//      2 578  myclipsv3/data/turkeyCityCentroids.ts
//      1 634  myclipsv3/compose/pipeline/searchNgrams.ts
//        688  myclipsv3/feed/venueChip.ts
//     ───────
//     78 070 B ham (≈ 25 KB gzip)
//
// Zincirin TEK girişi vardı: `Post.tsx` · `PostMobile.tsx` ·
// `PostDetailModalDesktop.tsx` üçünün de yazdığı statik
// `import ShareSheet from "./components/ShareSheet"` satırı. Üçü de ana
// pakette olduğu için sheet'in TAMAMI ilk boyama yolunda iniyordu — oysa
// paylaş sheet'i ilk boyamada **asla** görünmez; yalnız ✈️'ye basılınca açılır.
//
// ── DAVRANIŞ DELTASI SIFIR (kasıtlı) ─────────────────────────────────────
// Gövde zaten `if (!open) return null;` ile başlıyordu; yani kapalıyken
// hiçbir şey render etmiyordu ve `BottomSheet` kapanışta zaten ANINDA
// sökülüyordu (çıkış animasyonu bu yolda hiç oynamıyordu). Sarmalayıcı da
// `open` yanlışken `null` döndürür → aynı ağaç, aynı DOM, aynı geri-tuşu
// sözleşmesi. `Suspense` yedeği `null`dur: sheet bir ÖRTÜ katmanıdır, akışta
// yer kaplamaz → yer-tutucu koymak CLS üretirdi, koymamak üretmez.
//
// 🔒 KIRMIZI ÇİZGİ: aşağıdaki `import()` **dinamik kalmalıdır**. Statik
//    `import` yazmak yukarıdaki 78 KB'ı sessizce geri getirir ve hiçbir
//    davranış testi kırılmaz. Bunu `src/paylasSheetTembelKapisi.test.ts`
//    AST ile (metin eşleşmesiyle DEĞİL) ölçer.
import React, { Suspense, lazy } from "react";
import type { PaylasimEki, ShareSheetProps } from "./ShareSheetIcerik";

export type { PaylasimEki, ShareSheetProps };

const ShareSheetIcerik = lazy(() => import(/* webpackChunkName: "share-sheet" */ "./ShareSheetIcerik"));

export default function ShareSheet(props: ShareSheetProps) {
  // Gövdenin kendi `if (!open) return null` satırının aynısı — ama BURADA,
  // yani chunk hiç istenmeden. Kapalı sheet ağ isteği doğurmaz.
  if (!props.open) return null;
  return (
    <Suspense fallback={null}>
      <ShareSheetIcerik {...props} />
    </Suspense>
  );
}
